<section class="pt-20 overflow-hidden pb-28 sm:pt-32 sm:pb-40">
  <div class="mx-auto max-w-screen-2xl">
    <div class="w-10/12 mx-auto sm:w-9/12">
      <h3 class="text-white">
        {{ "shopguard.how_works.title" | translate }}
      </h3>
      <div
        class="relative flex flex-col-reverse mx-auto mt-8 max-w-screen-2xl xl:mt-12 xl:flex-row"
      >
        <div class="mx-auto lg:w-2/3">
          <div class="flex">
            <ul class="border-l-2 border-white/10 ml-3.5 md:ml-7">
              <li class="flex mb-10 -ml-1.5">
                <img
                  class="w-3 h-3 -ml-px mr-3.5 md:mr-9"
                  src="assets/img/VirtualQueue/white-dot.png"
                  alt="dot"
                />
                <img
                  class="w-10 h-10 mb-auto mr-3 md:mr-6"
                  src="assets/img/Shared/icon-clock.svg"
                  alt="clock"
                />
                <div class="text-gray">
                  <p class="-mt-1 text-xl leading-8 text-white font-bold">
                    {{ "shopguard.how_works.title1" | translate }}
                  </p>
                  <p class="text-xl leading-7">
                    {{ "shopguard.how_works.text1" | translate }}
                  </p>
                </div>
              </li>

              <li class="flex -ml-1.5 mb-10">
                <img
                  class="w-3 h-3 -ml-px mr-3.5 md:mr-9"
                  src="assets/img/VirtualQueue/white-dot.png"
                  alt="dot"
                />
                <img
                  class="w-10 h-10 mb-auto mr-3 md:mr-6"
                  src="assets/img/Shared/icon-mobile.svg"
                  alt="mobile"
                />
                <div class="text-gray">
                  <p class="-mt-1 text-xl leading-8 text-white font-bold">
                    {{ "shopguard.how_works.title2" | translate }}
                  </p>
                  <p class="text-xl leading-7">
                    {{ "shopguard.how_works.text2" | translate }}
                  </p>
                </div>
              </li>

              <li class="flex -ml-1.5">
                <img
                  class="w-3 h-3 -ml-px mr-3.5 md:mr-9"
                  src="assets/img/VirtualQueue/white-dot.png"
                  alt="dot"
                />
                <img
                  class="w-10 h-10 mb-auto mr-3 md:mr-6"
                  src="assets/img/Shared/icon-protection.svg"
                  alt="protection"
                />
                <div class="text-gray">
                  <p class="-mt-1 text-xl leading-7 text-white font-bold">
                    {{ "shopguard.how_works.title3" | translate }}
                  </p>
                  <p class="text-xl leading-7">
                    {{ "shopguard.how_works.text3" | translate }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="flex mx-auto xl:ml-5 xl:w-1/3 mb-9 xl:mb-0">
          <img
            class="object-cover"
            src="assets/img/Shopguard/Mockup-EN-600.gif"
            alt="Shopguard"
          />
        </div>
      </div>
    </div>
  </div>

  <button
    class="z-10 block w-full h-16 max-w-xs mx-auto font-bold rounded-l-full rounded-r-full mt-28"
    langRouterLink="contact_us"
  >
    {{ "shopguard.how_works.button" | translate }}
  </button>
</section>
